<template>
    <CieloLayout layout-version="v1">
        <div class="container text-center mt-5">
            <h1 class="error-title" tabindex="0">
                Oppsss!
            </h1>
            <h2 class="error-subtitle mt-3" tabindex="0">
                {{ $ml.get(resolvedMessage.titleKey) }}
            </h2>
            <span class="error-description d-block mt-5" tabindex="0">
                {{ $ml.get(resolvedMessage.descriptionKey) }}
            </span>
        </div>
    </CieloLayout>
</template>

<script>
const CieloLayout = () => import(
        /* webpackChunkName: "cielo-layout" */ '@/components/layout/CieloLayout'
);

const ERROR_CODE_RECURRENCE_FEE_NOT_ALLOWED = 'RECURRENCE_CONVENIENCE_FEE_NOT_ALLOWED';

const invalidLinkDefaultMessage = {
    titleKey: 'invalidLinkTitle',
    descriptionKey: 'invalidLinkDescription'
};

const invalidLinkMessagesByCode = {
    [ERROR_CODE_RECURRENCE_FEE_NOT_ALLOWED]: {
        titleKey: 'recurrencePaymentUnavailableTitle',
        descriptionKey: 'recurrencePaymentUnavailableDescription'
    }
};

export default {
    components: {
        CieloLayout
    },

    computed: {
        resolvedMessage() {
            const errorCode = this.$route.query.code;

            if (errorCode && invalidLinkMessagesByCode[errorCode]) {
                return invalidLinkMessagesByCode[errorCode];
            }

            return invalidLinkDefaultMessage;
        }
    }
};
</script>

<style lang="scss" scoped>
.error-title {
    font-size: 50px;
    font-weight: 700;
    color: $cielo-blue;
}

.error-subtitle {
    font-size: 25px;
    font-weight: 300;
    color: $cielo-blue;
}

.error-description {
    color: #5d666b;
}
</style>